import { PayloadAction } from '@reduxjs/toolkit';

import { ISearchState } from 'store/types/searchTypes';

export const setCurrentSearchTerm = (state: ISearchState, action: PayloadAction<string>) => {
  state.currentSearchTerm = action.payload;
};

export const setSearchFiltersForPdp = (
  state: ISearchState,
  action: PayloadAction<{ sizes?: string[]; instantShip?: boolean; shoeConditions?: string[] }>,
) => {
  const { sizes, instantShip, shoeConditions } = action.payload;

  state.instantShipSearchFilter = instantShip;
  state.sizeSearchFilter = sizes;
  state.conditionSearchFilter = shoeConditions;
};

export const clearSearchFiltersForPdp = (state: ISearchState) => {
  state.instantShipSearchFilter = false;
  state.sizeSearchFilter = [];
  state.conditionSearchFilter = [];
};
